import React, { memo } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import StepTitle from './StepTitle';

interface ILocationTitleProps {
  toggleLocation: (status: boolean) => void;
  value: boolean;
}
const LocationTitle = ({ toggleLocation, value }: ILocationTitleProps) => (
  <>
    <StepTitle
      eyebrow="Location"
      title="Job Location"
      description="Is this job remote?"
      mb={1}
    />
    <RadioGroup
      value={value}
      onChange={(event) => {
        const isRemote = event.target.value === 'true';
        toggleLocation(isRemote);
      }}
      sx={{
        mb: 4,
        gap: 1
      }}
    >
      <FormControlLabel
        data-cy="noneLocationCheckbox"
        control={<Radio sx={{ '& .MuiSvgIcon-root': { width: '16.7px', height: '16.7px' } }} />}
        label="Yes"
        value="true"
        sx={{
          '.MuiFormControlLabel-label': {
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 1.57
          },
          '.PrivateSwitchBase-root': { py: 0, pr: 1 }
        }}
      />
      <FormControlLabel
        control={<Radio sx={{ '& .MuiSvgIcon-root': { width: '16.7px', height: '16.7px' } }} />}
        label="No"
        value="false"
        sx={{
          '.MuiFormControlLabel-label': {
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 1.57
          },
          '.PrivateSwitchBase-root': { py: 0, pr: 1 }
        }}
      />
    </RadioGroup>
  </>
);

export default memo(LocationTitle);
